import { Injectable } from '@angular/core';
import { DataResult } from '@syncfusion/ej2-angular-grids';
import { Fetch } from '@syncfusion/ej2-base';
import { DataManager, ODataV4Adaptor } from '@syncfusion/ej2-data';
import { ChampsPersoService } from '../pages/champs-perso/services/champs-perso.service';
import { ConfigService } from '../services/config/config.service';
import { LocalStorageTokenService } from '../services/utilisateurs/local-storage-token.service';

@Injectable({
  providedIn: 'root',
})
export class ODataAdaptor extends ODataV4Adaptor {
  constructor(
    private localStorage: LocalStorageTokenService,
    private configService: ConfigService,
    private champsPersoService?: ChampsPersoService
  ) {
    super();
  }

  private sanitizeField(field: string): string {
    return field.replace(/\s+/g, '_').replace(/[^\w]/g, '');
  }

  override beforeSend(dm: DataManager, request: Request, settings: Fetch): void {
    const token = this.localStorage.getCurrentToken()?.value;
    const authz = this.localStorage.getCurrentAuthorizationToken()?.value;
    const headers = new Headers(request.headers);
    headers.set('Content-Type', 'application/json; charset=utf-8');
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    if (this.configService.isFusionAuthConfigured() && authz) {
      headers.set('Authorizations', authz);
    }
    const newRequest = new Request(request.url, {
      method: request.method,
      headers: headers,
      body: request.body,
    });
    settings.fetchRequest = newRequest;
  }

  override processResponse(
    data: any,
    ds?: any,
    query?: any,
    xhr?: Request
    ): DataResult {
      const original = super.processResponse(data, ds, query, xhr) as any;
      if (original.result) {
        if(!original.result.some(r =>r.ChampsAdditionnels)) return original;
        original.result.forEach((item: any) => {
        if (item.ChampsAdditionnels && Array.isArray(item.ChampsAdditionnels)) {
          item.ChampsAdditionnels.forEach((champ: any) => {
            item[this.sanitizeField(champ.Nom)] = champ.Valeur;
          });
        }
      });
    }
    if (Array.isArray(original.result)) {
      const uniqueChampsMap = new Map<string, any>();
      original.result.forEach((item: any) => {
        if (Array.isArray(item.ChampsAdditionnels)) {
          item.ChampsAdditionnels.forEach((champ: any) => {
            const sanitized = this.sanitizeField(champ.Nom);
            if (!uniqueChampsMap.has(sanitized)) {
              uniqueChampsMap.set(sanitized, {
                ...champ,
                Nom: sanitized
              });
            }
          });
        }
      });
      if (uniqueChampsMap.size > 0) {
        this.champsPersoService.setChamps(Array.from(uniqueChampsMap.values()));
      }else{
        this.champsPersoService.setChamps([]);
      }
    }
    return original;
  }
}
